import { InvoiceView } from '~/types/invoice';

export type TerminationRequestsContractView = {
  dt_encerramentocontrato: string;
  dt_inicialcontrato: string;
  empresa: string;
  id_contrato: number;
  mes_encerramentocontrato: string;
  nu_contrato: string;
  nu_mesescontrato: string;
  nu_pedido: string;
  tp_situacao: string;
  vencimento_final: string;
  vr_totalinicialcontrato: string;
  valor_mensal_atual: string;
  aviso_previo: number;
  multa: number;
  valor_multa: string;
  valor_total: string;
  limite_dias: number;
  qtde_faturas_aberto: number;
  total_faturas_vencidas: string;
  prazo_contrato: number;
  vencido_desde: string;
  equipamentos: TerminationRequestsEquipament[];
  faturas: InvoiceView[];
  nm_indicecorrecao: string;
  locador: string;
  cnpj: string;
};

export type TerminationRequestsEquipament = {
  id_contrato: number;
  id_equipamento: number;
  qtde_total: number;
  qtde_parcial: number;
  cd_equipamento: string;
  dh_ultimaatualizacao: string;
  ds_equipamento: string;
  id_modeloequipamento: number;
  nm_modeloequipamento: string;
  nm_tipoequipamento: string;
  tp_situacao: string;
  selecionado?: boolean;
  contrato?: number;
};

export type RequestProposalObj = {
  motivo: string;
  descricao_motivo: string;
  contratos: TerminationRequestsContractView[];
};

export type TerminationRequestsList = {
  descricao_cancelar_rescisao: string;
  descricao_motivo: string;
  dt_solicitacao: string;
  id: number;
  motivo: number;
  solicitante: number;
  status: number;
  usuario: string;
  empresa: {
    nm_razaosocial: string;
    cnpjFormatado: string;
  };
  grupo_economico: string;
  contratos: {
    nu_contrato: string;
  }[];
  solicitanteColor: string;
  solicitanteStr?: string;
  statusStr?: string;
  statusColor: string;
  nu_contratos: string;
};

export type TerminationRequestsContracVisualization = {
  contratos: TerminationRequestsContractView[];
  equipamentos: TerminationRequestsEquipament[];
  descricao_cancelar_rescisao: string;
  descricao_motivo: string;
  dt_solicitacao: string;
  id: number;
  motivo: string;
  solicitante: number;
  status: number;
  usuario: string;
  valor_total: number;
  valor_total_geral: number;
  desconto: number;
  grupoeconomico: string;
};

export type UpdateCalculation = {
  rescisao: number;
  desconto: number;
  contratos: UpdateCalculationContract[];
  valor_total?: number;
  valor_total_geral?: number;
};

export type UpdateCalculationContract = {
  contrato: number;
  aviso_previo: number;
  valor_mensal_atual: number;
  multa: number;
  valor_multa: number;
  valor_total: number;
  limite_dias: number;
};

export const statusMapCliente = [
  { label: 'SOLICITADA', color: 'purple' }, // ver solicitacao
  { label: 'TERMO DE RESCISÃO ENVIADO AO CLIENTE', color: 'orange' }, // ver solicitacao, seguir com rescisao
  { label: 'AGUARDANDO ASSINATURA DO TERMO DE RESCISÃO', color: 'green' }, // ver solicitacao
  { label: 'TERMO DE RESCISÃO ASSINADO', color: 'messenger' }, // ver solicitacao
  { label: 'CANCELADA', color: 'red' }, // ver solicitacao
];

export const statusMapAdmin = [
  { label: 'PENDENTE DE ANÁLISE', color: 'purple' }, // ver solicitacao, analisar solicitação
  { label: 'TERMO DE RESCISÃO ENVIADO AO CLIENTE', color: 'orange' }, // ver solicitacao
  { label: 'AGUARDANDO ASSINATURA DO TERMO DE RESCISÃO', color: 'green' }, // ver solicitacao
  { label: 'TERMO DE RESCISÃO ASSINADO', color: 'messenger' }, // ver solicitacao
  { label: 'CANCELADA', color: 'red' }, // ver solicitacao
];
